// extracted by mini-css-extract-plugin
module.exports = {"main":"StaleContentModule_main__iwzVK","closeBtnDiv":"StaleContentModule_closeBtnDiv__5mDLr","text":"StaleContentModule_text__vlHtJ","btn":"StaleContentModule_btn__nvcof"};